// AI Generated File
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { ActiveFeatureService } from '@monsido/services/active-feature/active-feature.service';

@Component({
    selector: 'page-details-dashboard-charts-qa',
    standalone: false,
    template: `
        <div class="row page-details-dashboard-qa">
            <div class="col-24 my-2 cursor-pointer" *ngFor="let violation of violations; let i = index">
                <notification
                        (callback)="navigateTo($event)"
                        [params]="violation.params"
                        [faIcon]="violation.icon"
                        [title]="violation.title"
                        [digit]="violation.digit"
                        [classColor]="violation.classColor">
                </notification>
                <span *ngIf="i % 2 === 0" class="vertical-ruler bg-grey vertical-ruler-right vertical-ruler-1"></span>
            </div>
        </div>
    `,
})
export class PageDetailsDashboardChartsQaComponent implements OnInit {
    @Input() page: any;
    @Output() onClickHandler = new EventEmitter<any>();

    violations: any[] = [];
    showBrokenLinks: boolean = false;
    showSpell: boolean = false;
    broken_links: number = 0;
    broken_images: number = 0;
    misspellings: number = 0;
    total: number = 0;
    totalErrors: number = 0;

    constructor (
        private translateService: TranslateService,
        private activeFeatureService: ActiveFeatureService,
    ) {}

    ngOnInit (): void {
        this.showBrokenLinks = this.activeFeatureService.isFeatureActivePure('qa_links');
        this.showSpell = this.activeFeatureService.isFeatureActivePure('qa_spellcheck');
        this.broken_links = this.page.dead_links_count;
        this.broken_images = this.page.dead_images_count;
        this.misspellings = this.page.spelling_errors_confirmed_count;
        this.total = this.page.quality_notification_count;
        this.totalErrors = this.page.error_score;
        this.setupViolations();
    }

    navigateTo (params: any): void {
        this.onClickHandler.emit(params);
    }

    private setupViolations (): void {
        this.violations = [];
        if (this.showBrokenLinks) {
            this.violations.push({
                title: this.translateService.getString('Broken Links'),
                digit: this.page.dead_links_count,
                classColor: 'text-link',
                icon: 'fas fa-unlink fa-3x',
                params: { target: 'page-details-section-qa', subTarget: 'brokenlinks' },
            });
            this.violations.push({
                title: this.translateService.getString('Broken Images'),
                digit: this.page.dead_images_count,
                classColor: 'text-link',
                icon: 'fas fa-file-image fa-3x',
                params: { target: 'page-details-section-qa', subTarget: 'brokenimages' },
            });
        }
        if (this.showSpell) {
            this.violations.push({
                title: this.translateService.getString('Potential Misspellings'),
                digit: this.page.spelling_errors_potential_count,
                classColor: 'text-link',
                icon: 'fas fa-language fa-3x',
                params: { target: 'page-details-section-qa', subTarget: 'potential' },
            });
            this.violations.push({
                title: this.translateService.getString('Misspellings'),
                digit: this.page.spelling_errors_confirmed_count,
                classColor: 'text-link',
                icon: 'fas fa-language fa-3x',
                params: { target: 'page-details-section-qa', subTarget: 'misspellings' },
            });
        }
    }
}
